// extracted by mini-css-extract-plugin
module.exports = {"root":"FilePreview_root__2dxyx","image":"FilePreview_image__27s3J","audio":"FilePreview_audio__2elqa"};